var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-item-wrapper"},[(_vm.icon)?_c('i',{staticClass:"menu-icon",class:_vm.icon}):_vm._e(),_c('span',{staticClass:"menu-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.isCustomerService && _vm.unread > 0)?_c('el-badge',{staticClass:"cs-badge",attrs:{"value":_vm.unread,"max":99}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }